import React, { useContext } from 'react';
import logo from '../../Assets/images/freshcart-logo.svg'
import { Link, useLocation } from 'react-router-dom';
import { AuthContxt } from '../AuthContext';
import { useNavigate } from 'react-router-dom';
import { Cartcontext } from '../Cartcontext';

export default function Navbar() {
  const { UserLoggedIn, setUserLoggedIn } = useContext(AuthContxt);
  const { cart } = useContext(Cartcontext);
  const navigate = useNavigate();
  const location = useLocation();

  function LogOut() {
    setUserLoggedIn(false);
    localStorage.removeItem('token');
    navigate('/login');
  }

  return (
    <>
      <nav className="navbar navbar-expand-lg bg-body-tertiary sticky-top">
        <div className="container">
          <Link className="navbar-brand" to={'home'}>
            <img src={logo} alt="fresh cart logo" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            {UserLoggedIn && (
              <ul className="navbar-nav mb-2 mb-lg-0">
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/home' ? 'active' : ''}`}
                    to={'home'}
                  >
                    Home
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/cart' ? 'active' : ''}`}
                    to={'cart'}
                  >
                    Cart
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/products' ? 'active' : ''}`}
                    to={'products'}
                  >
                    Products
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/categories' ? 'active' : ''}`}
                    to={'categories'}
                  >
                    Categories
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/brands' ? 'active' : ''}`}
                    to={'brands'}
                  >
                    Brands
                  </Link>
                </li>
                <li className="nav-item">
                  <Link
                    className={`nav-link ${location.pathname === '/wishlist' ? 'active' : ''}`}
                    to={'wishlist'}
                  >
                    Wish List
                  </Link>
                </li>
                <li className="nav-item d-flex align-items-center">
                  <i className="fa-solid fa-cart-shopping fa-2x position-relative mx-3">
                    <span className="position-absolute top-0 start-100 translate-middle px-2 py-1 text-white cart-number">
                      {cart?.numOfCartItems || 0}
                    </span>
                  </i>
                </li>
              </ul>
            )}
            <ul className="navbar-nav mb-2 mb-lg-0">
              {UserLoggedIn ? (
                <li onClick={LogOut} className="nav-item">
                  <span className="nav-link cursor-pointer logout">Log out</span>
                </li>
              ) : (
                <>
                  <li className="nav-item mx-2">
                    <Link
                      className={`nav-link ${location.pathname === '/login' ? 'active' : ''}`}
                      to={'login'}
                    >
                      Login
                    </Link>
                  </li>
                  <li className="nav-item">
                    <Link
                      className={`nav-link ${location.pathname === '/register' ? 'active' : ''}`}
                      to={'register'}
                    >
                      Register
                    </Link>
                  </li>
                </>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </>
  );
}